import request from '@/utils/service'

export function feeStandardListApi(data) {
  return request({
    url: '/chargePlan/list',
    method: 'post',
    params: data
  })
}
export function feeStandardDetailApi(data) {
  return request({
    url: '/chargePlan/detail',
    method: 'post',
    params: data
  })
}
export function addFeeStandardApi(data) {
  return request({
    url: '/chargePlan/add',
    method: 'post',
    data
  })
}
export function updateFeeStandardApi(data) {
  return request({
    url: '/chargePlan/update',
    method: 'post',
    data
  })
}
export function delFeeStandardApi(data) {
  return request({
    url: '/chargePlan/delete',
    method: 'post',
    data
  })
}
